/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMarketrateExprt.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/marketrate-exprt";

export class AutogenModelMarketrateExprt<RowType extends ModelRow> extends Endpoint<RowType, RowMarketrateExprtFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMarketrateExprt extends ModelRow<RowMarketrateExprtFields> {
	constructor(values?: Partial<RowMarketrateExprtFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMarketrateExprtFields {
	account_number: string;
	actual_delivery: string;
	actual_pickup: string;
	additional_stops: string;
	alt_location: string;
	billing_distance: string;
	brk_fuel_list: string;
	brk_loading_list: string;
	brk_stops_list: string;
	brk_total_paid: string;
	cargo_ins: string;
	carrier_code_list: string;
	carrier_fuel: string;
	carrier_linehaul: string;
	carrier_loading: string;
	carrier_manager: string;
	carrier_name: string;
	carrier_other_pay: string;
	carrier_stop_pay: string;
	carrier_type: string;
	commodity: string;
	commodity_code_list: string;
	company_id: string;
	company_type: string;
	consignee_addr: string;
	consignee_name: string;
	country: string;
	cubic_feet: string;
	cust_acc_chrgs: string;
	cust_load_list: string;
	cust_stop_chrgs: string;
	cust_stops_list: string;
	cust_total_paid: string;
	customer_code_list: string;
	customer_fuel: string;
	customer_linehaul: string;
	customer_loading: string;
	customer_name: string;
	delivery_appt: string;
	delivery_appt_tm: string;
	dest_appt_end: string;
	dest_city: string;
	dest_state: string;
	dest_zipcode: string;
	dispatcher: string;
	exclude_carrier: string;
	exclude_commodity: string;
	exclude_customer: string;
	exclude_location_code: string;
	exclude_order_type: string;
	exclude_revenue: string;
	freight_class: string;
	freight_mode: string;
	freight_value: string;
	ftp_address: string;
	ftp_directory: string;
	generic_equip_type: string;
	hazmat: string;
	is_active: string;
	is_sftp_active: string;
	lag_days: number;
	linear_feet: string;
	load_number: string;
	location_code_list: string;
	misc_names: string;
	move_distance: string;
	operations_user: string;
	order_book_tm: string;
	order_type_list: string;
	origin_city: string;
	origin_state: string;
	origin_zipcode: string;
	password: string;
	pay_date: string;
	payment_terms: string;
	pickup_appt: string;
	pickup_appt_end: string;
	pickup_appt_tm: string;
	port: number;
	process_days: number;
	reply_email: string;
	revenue_code_list: string;
	scac_code: string;
	service_level: string;
	shipment_excpt: string;
	shipper_address: string;
	shipper_name: string;
	spot_or_contract: string;
	status: string;
	team: string;
	total_charges: string;
	total_pickups: string;
	total_stopoffs: string;
	trailer_detail: string;
	trailer_type: string;
	unit_count: string;
	units_type: string;
	use_http: string;
	user_name: string;
	vendor: string;
	webservice_address: string;
	weight: string;
}

